module.exports = __webpack_public_path__ + "img/Alinma.5038a4b6.png";